import { useContext } from "react";
import context from "./context";
import checkRole from "./hasPermission";
import { hasFeatureFlag as checkFeatureFlag } from "./featureFlags";

const useAccess = () => {
  const {
    permissions,
    initialRoutePath,
    permissionGuideUrl,
    resourcePolicies,
    featureFlags,
    resources,
    isLoaded,
    define,
  } = useContext(context);

  const hasPermission = (role, opts = {}) => {
    return checkRole(permissions, resources, role, opts);
  };

  const hasFeatureFlag = (flag) => checkFeatureFlag(featureFlags, flag);

  return {
    isLoaded,
    hasPermission,
    hasFeatureFlag,
    define,
    permissions,
    initialRoutePath,
    permissionGuideUrl,
    resourcePolicies,
    featureFlags,
  };
};

export default useAccess;
